import { makeStyles } from '@material-ui/core/styles';

// Selectors must live on a parent of the markup ApexCharts injects via
// `tooltip.custom` — that markup is not part of the React tree.
export const chartTooltipStyles = {
  '& .apexcharts-tooltip': {
    border: 'none',
    boxShadow: 'none',
    background: 'transparent',
    overflow: 'visible',
    borderRadius: '16px',
  },
  '& .apexcharts-tooltip-title': {
    display: 'none',
  },
  '& .chartTooltip': {
    background: '#fff',
    borderRadius: '16px',
    padding: '14px 22px 16px',
    boxShadow: '0 6px 24px rgba(0, 0, 0, 0.14)',
    minWidth: '120px',
    fontFamily: 'inherit',
  },
  '& .chartTooltip__head': {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    marginBottom: '4px',
  },
  '& .chartTooltip__dot': {
    width: '12px',
    height: '12px',
    borderRadius: '50%',
    background: '#00d456',
    flexShrink: 0,
  },
  '& .chartTooltip__label': {
    color: '#00d456',
    fontSize: '13px',
    fontWeight: 700,
    letterSpacing: '0.06em',
    textTransform: 'uppercase',
  },
  '& .chartTooltip__count': {
    color: '#161616',
    fontSize: '36px',
    fontWeight: 800,
    lineHeight: 1,
    textAlign: 'center',
  },
  '& .chartTooltip__sublabel': {
    color: '#9e9e9e',
    fontSize: '13px',
    fontWeight: 600,
    letterSpacing: '0.06em',
    textTransform: 'uppercase',
    marginTop: '2px',
  },
  '& .chartTooltip--multi': {
    padding: '12px 18px 14px',
    minWidth: '200px',
  },
  '& .chartTooltip__title': {
    color: '#9e9e9e',
    fontSize: '12px',
    fontWeight: 700,
    letterSpacing: '0.06em',
    textTransform: 'uppercase',
    marginBottom: '8px',
  },
  '& .chartTooltip__row': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '16px',
    padding: '2px 0',
  },
  '& .chartTooltip__rowLabel': {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  '& .chartTooltip__rowCount': {
    color: '#161616',
    fontSize: '14px',
    fontWeight: 700,
  },
};

export const useChartTooltipStyles = makeStyles(() => ({
  chartWrapper: { ...chartTooltipStyles },
}));
